import { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Dialog } from './Dialog';
import { useT } from '../i18n';

interface Props {
  open: boolean;
  codes: string[];
  onClose: () => void;
}

// Модал одноразового показа recovery-кодов. Backend выдаёт коды только
// один раз (при enrollment первого passkey или regenerate). UI должен
// дать скопировать всё разом и предупредить о невосстановимости.
export function RecoveryCodesDialog({ open, codes, onClose }: Props) {
  const t = useT();
  const [copied, setCopied] = useState(false);

  async function copyAll() {
    try {
      await navigator.clipboard.writeText(codes.join('\n'));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // ignore — пользователь увидит коды на экране
    }
  }

  return (
    <Dialog open={open} onClose={onClose} title={t('security.recovery.previewTitle')}>
      <div className="space-y-4">
        <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900">
          {t('security.recovery.warning')}
        </div>
        <ul className="grid grid-cols-2 gap-2 rounded-md border border-slate-200 bg-slate-50 p-3 font-mono text-sm text-slate-800">
          {codes.map((c) => (
            <li key={c} className="select-all">
              {c}
            </li>
          ))}
        </ul>
        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={copyAll}
            className="inline-flex items-center gap-1.5 rounded-md border border-slate-200 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50"
          >
            {copied ? (
              <>
                <Check className="h-4 w-4 text-emerald-600" />
                {t('security.recovery.copied')}
              </>
            ) : (
              <>
                <Copy className="h-4 w-4" />
                {t('security.recovery.copy')}
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-accent-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-accent-700"
          >
            {t('security.recovery.done')}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
